import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  VendorMaterialStockItemDetailsResponseData,
  UseGetVendorMaterialStockItemDetailsParams,
  UseGetVendorMaterialStockItemDetailsQueryKey,
} from './types';
import { getUseGetVendorMaterialStockItemDetailsQueryKey } from './utils';

export const useGetVendorMaterialStockItemDetails: QueryFunction<
  VendorMaterialStockItemDetailsResponseData,
  [UseGetVendorMaterialStockItemDetailsParams],
  UseGetVendorMaterialStockItemDetailsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getUseGetVendorMaterialStockItemDetailsQueryKey(params);

  return useQuery({
    enabled: !!params.id,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/vendors/material_stock_item/${params.id}`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    ...queryOptions,
  });
};
